import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";
import Axios from "axios";
import Swiper, { Autoplay, Lazy, Pagination, A11y } from "swiper";
import LightGallery from "lightgallery.js";

(<any>window).Vue = Vue;
(<any>window).Vuex = Vuex;
(<any>window).VueRouter = VueRouter;
(<any>window).Axios = Axios;
(<any>window).Swiper = Swiper;
(<any>window).Autoplay = Autoplay;
(<any>window).Lazy = Lazy;
(<any>window).Pagination = Pagination;
(<any>window).A11y = A11y;
(<any>window).LightGallery = LightGallery;